module.exports = __webpack_public_path__ + "img/section-background.015fb4eb.svg";